class UpdateConversationImageReq{
    constructor(){
        this.conversationId = null;
        this.image = null
    }
}
export default UpdateConversationImageReq;